import http from 'axios'

export default {
  getRecolte: (username, anneeRecolte, filtreNumeroBonApport, filtreTypeContratApport, filtreNumeroContratApport, filtreMoisApport, filtreGraineValoriseeApport) => {
    let params = ''
    if (filtreNumeroBonApport != null || filtreTypeContratApport != null || filtreNumeroContratApport != null || filtreMoisApport != null || filtreGraineValoriseeApport != null) {
      params += '?'
    }
    if (filtreNumeroBonApport != null) {
      params += `filtreNumeroBonApport=${filtreNumeroBonApport}&`
    }
    if (filtreTypeContratApport != null) {
      params += `filtreTypeContratApport=${filtreTypeContratApport}&`
    }
    if (filtreNumeroContratApport != null) {
      params += `filtreNumeroContratApport=${filtreNumeroContratApport}&`
    }
    if (filtreMoisApport != null) {
      params += `filtreMoisApport=${filtreMoisApport}&`
    }
    if (filtreGraineValoriseeApport != null) {
      if (filtreGraineValoriseeApport.codeGraineValorisee) {
        params += `filtreGraineValoriseeApport=${filtreGraineValoriseeApport.codeGraineValorisee}&`
      } else {
        params += `filtreGraineValoriseeApport=Tous&`
      }
    }
    //enlève le dernier &
    params = params.slice(0, -1)
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}${params}`)
  },
  getResumeRecolteParGraine: (username, anneeRecolte) => {
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}/resume`)
  },
  getPdfApport: (username, moisDebutSelectionRecolte, moisFinSelectionRecolte, graineRs3) => {
    return http({
      url: `/web/v1/${username}/recoltes/${moisDebutSelectionRecolte}/${moisFinSelectionRecolte}/apport/${graineRs3}/pdf`,
      method: 'GET',
      responseType: 'blob'
    })
  },
  getResumeApportRecolteParGraine: (username, anneeRecolte, nbApports) => {
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}/resume-apport?nbApports=${nbApports}`)
  },
  getRepartitionApportParGraine: (username, anneeRecolte, codeGraine) => {
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}/repartition?codeGraine=${codeGraine}`)
  },
  getRecoltesContractualiseesEtRecoltees: (username) => {
    return http.get(`/web/v1/${username}/recoltes/contractualisees-et-recoltees`)
  }
}
